import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Text, { TEXT_SIZE, TEXT_COLOR } from '@components/Text';
import { getMessagingDate } from '@utils/timeHelpers';
import { getAgeAndEmailText } from '@containers/Admin/containers/UserPage/helpers';
import { markConversationReadLocallyAction } from '../../actions';
import {
  Wrapper,
  MenuItem,
  StyledPersonIcon,
  NewConversationText,
  MessageWrapper,
  StyledAvatar,
  MessageInfoWrapper,
  UserPrimaryInfo,
  MessageTextWrapper,
  EndedBadge,
  MessageContentWrapper,
  UnreadIndicator,
} from './styles';

const truncateText = (text, maxLength = 30) => {
  if (text && text.length > maxLength) {
    return `${text.substring(0, maxLength)}...`;
  }
  return text;
};

const getConversationPreviewText = (payload, t) => {
  if (payload?.kind === 'voice' || payload?.attachments?.some((attachment) => attachment?.type === 'audio')) {
    return t('Informative.Notifying.voiceMessage');
  }

  return truncateText(payload?.text || '');
};

export class MessagesList extends Component {
  renderNewConversationItem = () => {
    const {
      isNewConversationStarted,
    } = this.props;
    if (!isNewConversationStarted) return null;
    return (
      <MenuItem newItem>
        <StyledPersonIcon />
        <NewConversationText>
          <Text size={TEXT_SIZE.H4} textColor={TEXT_COLOR.NORMAL}>
            {this.props.t('Informative.Notifying.newMessages')}
          </Text>
        </NewConversationText>
      </MenuItem>
    );
  };

  renderList = () => {
    const {
      conversations,
      currentConversation,
      chooseConversation,
      markConversationReadLocally,
    } = this.props;
    return conversations.map((conversation) => {
      const { Thread, Users, id } = conversation;
      const post = Thread.Posts[0];
      if (!post) return null;
      const user = Users.find((userData) => !userData.self);
      const ageAndEmailText = getAgeAndEmailText(user);
      if(!user?.fullName) return <></>
      return (
        <MenuItem
          key={id}
          isCurrent={id === currentConversation?.id}
          onClick={() => {
            chooseConversation(conversation);
            if (Thread.unread) {
              markConversationReadLocally(id);
            }
          }}
        >
          {user?.avatar ? <StyledAvatar src={user.avatar} /> : <StyledPersonIcon />}
          <MessageWrapper>
            <MessageInfoWrapper>
              <UserPrimaryInfo>
                <Text
                  size={TEXT_SIZE.H4}
                  textColor={TEXT_COLOR.NORMAL}
                  weight={post.unread ? 'bold' : 'normal'}
                >
                  {user?.fullName}
                </Text>
                {ageAndEmailText && (
                  <Text
                    size={TEXT_SIZE.T5}
                    textColor={TEXT_COLOR.DISABLED}
                  >
                    {ageAndEmailText}
                  </Text>
                )}
              </UserPrimaryInfo>
              <Text size={TEXT_SIZE.T4} textColor={TEXT_COLOR.DISABLED}>
                {getMessagingDate(post.createdAt)}
              </Text>
              {Thread.unread && <UnreadIndicator />}
            </MessageInfoWrapper>
            <MessageContentWrapper>
              <MessageTextWrapper>
                {post.self && (
                  <Text
                    size={TEXT_SIZE.T4}
                    textColor={TEXT_COLOR.DISABLED}
                    margin="0 5px 0 0"
                    weight="bold"
                  >
                    {this.props.t('Common.UI.you') + ': '}
                  </Text>
                )}
                <Text
                  size={TEXT_SIZE.T4}
                  textColor={
                    post.unread ? TEXT_COLOR.DARK_BLUE : TEXT_COLOR.DISABLED
                  }
                  weight={post.unread ? 'bold' : 'normal'}
                >
                  {getConversationPreviewText(post.payload, this.props.t)}
                </Text>
              </MessageTextWrapper>
              {Thread.closed && (
                <EndedBadge>
                  <Text size={TEXT_SIZE.T4} textColor={TEXT_COLOR.WARNING}>
                    {this.props.t('Common.UI.ended').toUpperCase()}
                  </Text>
                </EndedBadge>
              )}
            </MessageContentWrapper>
          </MessageWrapper>
        </MenuItem>
      );
    });
  };

  render() {
    return (
      <Wrapper>
        {this.renderNewConversationItem()}
        {this.renderList()}
      </Wrapper>
    );
  }
}

MessagesList.propTypes = {
  conversations: PropTypes.array,
  currentConversation: PropTypes.object,
  isNewConversationStarted: PropTypes.bool,
  chooseConversation: PropTypes.func,
  markConversationReadLocally: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  markConversationReadLocally: (conversationId) => dispatch(markConversationReadLocallyAction(conversationId)),
});

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps),
)(MessagesList);
